
import { Component, Vue } from 'vue-property-decorator';

import Form2ProcessHeader from "@/components/process/Form2/components/Form2ProcessHeader.vue";
import Form2StyleOfProceeding from "@/components/process/Form2/components/Form2StyleOfProceeding.vue";
import { form2StatusInfoType } from '@/types/Information/Form2';

@Component({
    components:{
        Form2ProcessHeader,        
        Form2StyleOfProceeding
    }
})
export default class FillForm2 extends Vue {

    stepsCompleted = {} as form2StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
